export class FiveDayLadderSelection {
    currency: string;
    inAmount: number;
    outAmount: number;
    constructor() {
    }
}
